export function formatFormLabel(form) {
  if (!form) return '';
  if (form === 'Normal') return 'Normal';

  const withSpaces = String(form).replace(/_/g, ' ');

  return withSpaces
    .split(/\s+/)
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

